import React, { useState, useEffect, useRef } from "react";
import { findDOMNode } from 'react-dom';
import classes from "./home.module.scss";
import { Outlet } from "react-router-dom";
import logo from "../../Resources/nav_resources/StarB.png";
import { AiOutlineMenu } from "react-icons/ai";
import { AiOutlineClose } from "react-icons/ai";
import herobannerimg from "../../Resources/herobanner/Maskgroup.png";
import store, { ODSFutureActions,authenticationActions } from "../../store/store";
import { useSelector } from "react-redux";
import { personActions } from "../../store/store";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import { TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from '../../Shared/Utill/AuthUtil';
import BreadcrumbView from "../../Shared/Breadcrumb/BreadcrumbView.js";
import { workScheduleActions } from "../../store/store";
import Cookie from "js-cookie";
import { Typography, Link, Breadcrumbs } from '@mui/material';
import { Button } from "@mui/material";

// mobile imports 
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ActAsUser from '../../Resources/homepage/act_as_user.png';
import User from '../../Resources/homepage/user.png';
import Division from '../../Resources/homepage/division.png';
import Store from '../../Resources/homepage/store.png';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import KeyboardArrowLeftSharpIcon from '@mui/icons-material/KeyboardArrowLeftSharp';
import ErrorComponent from "../../Shared/Layout/Error";
import {messages} from "../../Shared/Messages/ErrorMessages";
import { useJwt, isExpired } from "react-jwt";
import moment from "moment";
import { selectedLanguageActions } from "../../store/store";
import Cookies from "js-cookie";




const Home = (props) => {
  //details will be from person state
  console.log("Checking for redux state: ", store.getState());
  const personDetails = useSelector((state) => state.person.personData);
  const personODSFuture = useSelector((state) => state.odsfuture.ODSFutureData);
  console.log("token: ", personDetails.posting_TKN)
  // Checking whether to use props/redux based on availability.

  console.log("PROP VERSION OF URLS ",JSON.stringify(props.urlLocalState));
  const urlReduxDetails =  useSelector((state) => state.url.urlData);
  console.log("Redux VERSION OF URLS ",JSON.stringify(urlReduxDetails));
  const urlDetails = Object.keys(urlReduxDetails).length > 0 ? urlReduxDetails: props.urlLocalState;
  console.log("Person Details on Home Page: ", personODSFuture)
  const [impersonatePerson, setImpersonatePerson] = useState("");
  const [isImpersonateBoxOpen, setImpersonateBox] = useState(false);
  const [isInvalidEmployee, setIsInvalidEmployee] = useState(false);
  const navigate = useNavigate();
  const token = Cookie.get('X_TKN');
  const tkn_validity = useJwt(token);
  const history = useNavigate();
  const { pathname } = useLocation();
  const pathnames = pathname.split("/").filter(Boolean);
  
  // side drawer
  const [state, setState] = React.useState({left: false});
  const [logoutDrawer, setLogoutDrawer] = useState(false);
  const [availabilityDrawer, setAvailabilityDrawer] = useState(false);
  const [activeApps, setActiveApps] = useState([]);
  const [activeEvents, setactiveEvents] = useState([]);
  const [isEventsVisible, setIsEventsVisible] = useState(false);
  const [businessDate, setBusinessDate] = React.useState(new Date());
  const personStaticDetails = useSelector((state) => state.personStatic.personStaticData);
  const [sendToLogout,setSendToLogout] = React.useState(false);
  const [noWS,setNoWS] = React.useState(false);
  // language changes
  const [languageSelected, setLanguage] = useState("en");
  const [languages, setLanguages] = useState([]);
  const ref = useRef(false)

  /* code for the availability drawer */
  console.log("Redux State in home",store.getState());
  const csrf_TKN = Cookie.get("csrf");
  console.log("Here is the csrf token before get my apps api call. " + csrf_TKN )

  const reset = () => {
    /*The idea here is that when home is being loaded after a logout -> login, it will reload to make
    sure it gets the personDetails, just need to make sure it doesn't loop. */
    if (Object.keys(personDetails).length < 1) {
      //window.location.reload()
      console.log("Something is very off about this.")
    }
  }
  useEffect(() => {
    reset()
    // Plz work
    console.log("person details in home ****", personDetails)
    
    if(Object.keys(personODSFuture).length === 0){
      console.log("INside Empty WS useEffect");
      setNoWS(true);
      return;
    }
    
    //payload
    const data = {
      //tkn:personDetails.cookiez.posting_TKN,
      // divNbr: personDetails.mydiv,
      // locNbr: personDetails.mystore,
      // dpt: personDetails.mydept,
      // ws: personDetails.workschedule,
      divNbr: personODSFuture.mydiv,
      locNbr: personODSFuture.mystore,
      dpt: personODSFuture.mydept,
      ws: personODSFuture.myworkschedule,
    }; 
      
    const eventData = 
    {
       // tkn:personDetails.cookiez.posting_TKN,
        divNbr: personODSFuture.mydiv,
        locNbr: personODSFuture.mystore,
        dpt: personODSFuture.mydept,
        myWorkSchedule: personODSFuture.myworkschedule,
        myDateDisplayed : "",
        ascNbr: personDetails.emplID,
        
    }
  
    let dateData = {
      // divNbr: personDetails.mydiv,
      // appAbbr: "AVL",
      // locNbr: personDetails.mystore,
      // dptNbr : personDetails.mydept,
      // myWorkSchedule: personDetails.workschedule,
      // minified:0,
      // myWorkSchedule: personDetails.workschedule,
      divNbr: personODSFuture.mydiv,
      appAbbr: "AVL",
      locNbr: personODSFuture.mystore,
      dptNbr : personODSFuture.mydept,
      myWorkSchedule: personODSFuture.myworkschedule,
      minified:0,
      today: moment().format("YYYY-MM-DD"),
    }

    // get details of multilingual languages
    axiosInstance.get( `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_ALL_LANGUAGE_CODES}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {
       setLanguages(response.data);
       ref.current = true;
      })
      .catch((error) => {
       // ref.current = true;
       // setLanguages(["en","es","zh-CN","ko","fa","vi"]);
       
      }) 

    if (Object.keys(personDetails).length !== 0 && personDetails.empStatus !== "Terminated") {
        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLAPPS}`, data, {
          headers: {
            'content-type': 'application/json',
            'Authorization':'Bearer ' + token
          }
        })
        .then((response) => {
          setActiveApps(response.data)
        })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLAPPS}...failed`})
        }
      })

      // get all events api
      axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLEVENTS}`, eventData, {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
        let data = response.data;
        let active = false;
        active = data.some(obj => obj.result === "True"); 
        setIsEventsVisible(active);
        setactiveEvents(data);
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLEVENTS}...failed`})
        }
      });

      // get first available edit date
      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_AVL_FIRST_EDIT_DATE}`, dateData , {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
        let data = response.data[0].calDate;
        setBusinessDate(data)
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_GET_AVL_FIRST_EDIT_DATE}...failed`})
        }
      }); 

    }
  }, []);


  // code for multilingual starts

  function loadTranslateScript(){
    const translateRef = document.getElementById('google_translate_element');
    var selectConfig = {
      attributes: true,
      childList: true,
      subtree: true
    };
    var selectObserver = new MutationObserver(()=>{removeTranslateElements("from select observer")});
    selectObserver.observe(translateRef, selectConfig);
    const htmlRef = document.getElementById('htmlID');
    var htmlConfig = {
      attributes: true,
      attributeOldValue: true,
      attributeFilter: ['class'] 
    };
    var htmlObserver = new MutationObserver(()=>{htmlClassChange("from html observer")});
    htmlObserver.observe(htmlRef, htmlConfig);

    //test
    
    // const bodyRef = document.getElementById('bodyID');
    // var bodyConfig = {
    //   attributes: true,
    //   childList: true,
    //   subtree: true
    // };
    // var bodyObserver = new MutationObserver(()=>{bodyChange("from body observer")});
    // bodyObserver.observe(bodyRef, bodyConfig);
    
    if(translateRef.children.length === 0){
      // Cookies.set("googtrans", "/auto/en", {domain: ".google.com"});
      let transCookie = Cookies.get("googtrans");
      // console.log("Tranlsation Cookie");
      // console.log(transCookie);
      if(!transCookie){
        Cookies.set("googtrans", "/auto/en");
      }
      const script = document.createElement('script');
      script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.type = "text/javascript";
      script.async = true;
      script.defer = true;
      translateRef.appendChild(script);
      const script2 = document.createElement('script');
      script2.type = "text/javascript";
      script2.async = true;
      script2.innerHTML = "function googleTranslateElementInit() {new google.translate.TranslateElement({includedLanguages : '"+languages+"'}, 'google_translate_element');}"
      translateRef.appendChild(script2);
      
    }
    bodyChange("test");
    
  }

  useEffect(() => {
    if(ref.current) {
      // here your state is updated so you can perform your action that you want to be executed 
      loadTranslateScript(); 
      ref.current = false;
    }
        
  }, [languages]);

  function bodyChange(message){
    console.log(message);
    const bodyRef = document.getElementById('bodyID');
    console.log("|||| Body Ref ||||");
    console.log(bodyRef);
    console.log("|||| Body Chilren ||||");
    console.log(bodyRef.children);
    if(bodyRef){
      if(bodyRef.children.length > 4){
        if(bodyRef.children[4].children.length > 0){
          if(bodyRef.children[4].children[0].children.length > 0){
            console.log("|||| element ||||");
            console.log(bodyRef.children[4].children[0].children[0]);
            console.log("|||| tagName ||||");
            console.log(bodyRef.children[4].children[0].children[0].tagName);
            if(bodyRef.children[4].children[0].children[0].tagName === "svg"){
              bodyRef.children[4].remove();
            }
          }
        }
      }
    }
  }

  function htmlClassChange(message){
    console.log(message);
    const htmlRef = document.getElementById('htmlID');
    console.log("|||| HTML REF ||||")
    console.log(htmlRef);
    if(htmlRef){
      if(htmlRef.classList.contains('translated-ltr')){
        htmlRef.className = htmlRef.className.replace( /(?:^|\s)translated-ltr(?!\S)/g , '' )
      }
    }
    
  }

  function removeTranslateElements(message) {
    console.log(message);
    const translateRef = document.getElementById('google_translate_element');
    console.log(translateRef);
    
    if(translateRef){
      console.log(translateRef.children.length);
      console.log(translateRef.children);
      if(translateRef.children.length > 2){
        if(translateRef.children[2].childNodes.length > 1){
          translateRef.children[2].childNodes[2].remove();
          translateRef.children[2].childNodes[1].remove();
          translateRef.children[2].children[0].children[0].style.background = "rgb(255, 255, 255)";
          translateRef.children[2].children[0].children[0].style.color = "rgb(0, 0, 0)";
          translateRef.children[2].children[0].children[0].style.border ="2px inset rgb(118, 118, 118)";
          translateRef.children[2].children[0].children[0].style.cursor = "pointer";
          translateRef.children[2].children[0].children[0].style["border-radius"] = "5px"
          
        }else{
          console.log("|||||| Children.childnodes Length not greater than 1");
          if(translateRef.children[2].childNodes.length === 1){
            console.log("child")
            console.log(translateRef.children[2].children[0].children[0])
            console.log("selection value");
            console.log(translateRef.children[2].children[0].children[0].value);
            setLanguage(translateRef.children[2].children[0].children[0].value);
            bodyChange("langauge change");
            // IF language is changed update it in redux store
            if(translateRef.children[2].children[0].children[0].value !== "") {
            let selectLanguage = {selected: translateRef.children[2].children[0].children[0].value};
            store.dispatch(selectedLanguageActions.resetSelectedLanguageState())
            store.dispatch(selectedLanguageActions.setSelectedLanguageState(selectLanguage));
            }
            
          }
        }
      }else{
        console.log("|||||| Children Length less than 1");
      }
    }else{
      console.log("|||||| Google Translate Element Not Found");
    }
    
  };

  // code for multilingual ends

  useEffect(() => {

    // get details of multilingual languages
    axiosInstance.get( `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_ALL_LANGUAGE_CODES}`, {
      headers: {
        'content-type': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    })
      .then((response) => {
       setLanguages(response.data);
       ref.current = true;
      })
      .catch((error) => {
        ref.current = true;
        setLanguages(["en","es","zh-CN","ko","fa","vi"]);
       
      }) 

    if(Object.keys(personODSFuture).length === 0){
      //navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
      setNoWS(true);
      return;
    }
    //payload
    const data = {
      //tkn:personDetails.cookiez.posting_TKN,
      // divNbr: personDetails.mydiv,
      // locNbr: personDetails.mystore,
      // dpt: personDetails.mydept,
      // ws: personDetails.workschedule,
      divNbr: personODSFuture.mydiv,
      locNbr: personODSFuture.mystore,
      dpt: personODSFuture.mydept,
      ws: personODSFuture.myworkschedule,
    }; 
      
    const eventData = 
    {
       // tkn:personDetails.cookiez.posting_TKN,
        divNbr: personODSFuture.mydiv,
        locNbr: personODSFuture.mystore,
        dpt: personODSFuture.mydept,
        myWorkSchedule: personODSFuture.myworkschedule,
        myDateDisplayed : "",
        ascNbr: personDetails.emplID,
        
    }
  
    let dateData = {
      // divNbr: personDetails.mydiv,
      // appAbbr: "AVL",
      // locNbr: personDetails.mystore,
      // dptNbr : personDetails.mydept,
      // myWorkSchedule: personDetails.workschedule,
      // minified:0,
      // myWorkSchedule: personDetails.workschedule,
      divNbr: personODSFuture.mydiv,
      appAbbr: "AVL",
      locNbr: personODSFuture.mystore,
      dptNbr : personODSFuture.mydept,
      myWorkSchedule: personODSFuture.myworkschedule,
      minified:0,
      today: moment().format("YYYY-MM-DD"),
    }
   // console.log("person details in home ***", personDetails)
    
    if (Object.keys(personDetails).length !== 0 && personDetails.empStatus !== "Terminated") {
        axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLAPPS}`, data, {
          headers: {
            'content-type': 'application/json',
            'Authorization':'Bearer ' + token
          }
        }).then((response) => { 
        //TODO: uncomment below line and comment above to run locally 
        

        setActiveApps(response.data)
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLAPPS}...failed`})
        }
      })

    // get all events api
      axiosInstance.post(`${/*environmentVariables.avlApiUrl*/urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COMMON_GETALLEVENTS}`, eventData, {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
       //TODO: uncomment below line and comment above to run locally 
       
        console.log("-----event", response.data)
        let data = response.data;
        
        let active = false;
        active = data.some(obj => obj.result === "True"); 
        setIsEventsVisible(active);
        setactiveEvents(data);
        
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_COMMON_GETALLEVENTS}...failed`})
        }
      });

      // get first available edit date
      axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_AVL_FIRST_EDIT_DATE}`, dateData , {
        headers: {
          'content-type': 'application/json',
          'Authorization':'Bearer ' + token
        }
      }).then((response) => {
        let data = response.data[0].calDate;
        setBusinessDate(data)
      })
      .catch((error) => {
        if(error.message === 'Network Error') {
          navigate("/somethingwentwrong", {state:`Please logout and try again `})
        } else {
        navigate("/somethingwentwrong", {state:`${constants.WFM_GET_AVL_FIRST_EDIT_DATE}...failed`})
        }
      }); 

    }
    
    
 // }, [personDetails.impersonate_admin_id]); 
 }, [personODSFuture]); 



  /* code ends for the availability drawer */

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const toggleLogout = () => {
    setLogoutDrawer(false)
  }

  const toggleAvailability = () => {
    setAvailabilityDrawer(false)
  }
  

  const list = (anchor) => (
    <Box
      sx={{ width: 280 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        
          <ListItem key={"Act as user"} disablePadding>
            <ListItemButton>
              <ListItemIcon>
              <img src={ActAsUser}  /> 
              </ListItemIcon>
              {personDetails.impersonate_admin_id === null &&
              <ListItemText primary={"Act as user"} onClick={() => { setLogoutDrawer(false);impersonateBoxOpen()}} />
              }
              {personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined && (
                <ListItemText primary={"Act as user"} onClick={undefined} style={{color: "#949494"}} />
              ) }
              <KeyboardArrowRightSharpIcon className={classes.pointer} style={{color: personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined ? "#949494" : ""}} />
               
            </ListItemButton>
          </ListItem>
          <Divider/>
          <ListItem key={"empid"} disablePadding>
            <ListItemButton onClick={() => setLogoutDrawer(true)}>
              <ListItemIcon>
              <img src={User}  /> 
              </ListItemIcon>
              <ListItemText primary={`${personDetails.emplID} - ${personDetails.fullName}`} />
              <KeyboardArrowRightSharpIcon className={classes.pointer} />
            </ListItemButton>
          </ListItem>
          <ListItem key={"division"} disablePadding>
            <ListItemButton>
              <ListItemIcon>
              <img src={Division}  />  
              </ListItemIcon>
              <ListItemText primary={`Division - ${personDetails.mydiv}`} />
            </ListItemButton>
          </ListItem>
          <ListItem key={"store"} disablePadding>
            <ListItemButton>
              <ListItemIcon>
              <img src={Store}  /> 
              </ListItemIcon>
              <ListItemText primary={`Store - ${personDetails.mystore}`} />
            </ListItemButton>
          </ListItem>
          <Divider/>
          <ListItem key={"availability"} onClick={() => setAvailabilityDrawer(true)} disablePadding>
            <ListItemButton>
              
              <ListItemText>Availability</ListItemText>
              <KeyboardArrowRightSharpIcon className={classes.pointer} />
            </ListItemButton>
          </ListItem>

        
      </List>
    </Box>
  );


  const listLogout = (anchor) => (
    <Box
      sx={{ width: 280 }}
      role="presentation"
      onKeyDown={() => setLogoutDrawer(false)}
    >
      <List>
        
          <ListItem key={"Logout"} disablePadding>
            <ListItemButton onClick={toggleDrawer('left', true)} className={classes.bottomMargin} >
              <ListItemIcon className={classes.backArrow}>
              <KeyboardArrowLeftSharpIcon onClick={() => toggleLogout()} />
              </ListItemIcon>
               <b onClick={() => toggleLogout()}>My Account</b>              
               
            </ListItemButton>
          </ListItem>
          <Divider/>
          <ListItem key={"empid"} disablePadding>
            <ListItemButton>              
              <ListItemText onClick={logout} primary={"Logout"} />
            </ListItemButton>
          </ListItem>
          

        
      </List>
    </Box>
  );

  const listAvailability = (anchor) => (
    <Box
      sx={{ width: 280 }}
      role="presentation"
      onKeyDown={() => setAvailabilityDrawer(false)}
    >
      <List>
        
          <ListItem key={"Availability"} disablePadding >
            <ListItemButton onClick={toggleDrawer('left', true)} className={classes.bottomMargin} >
              <ListItemIcon className={classes.backArrow}>
              <KeyboardArrowLeftSharpIcon onClick={() => toggleAvailability()} />
              </ListItemIcon>
               <b onClick={() => toggleAvailability()}> Availability</b>              
               
            </ListItemButton>
          </ListItem>
          <Divider/>
          {isEventsVisible && personDetails.empStatus !== "Terminated" && (  
          <ListItem key={"availabilityid"} disablePadding>
            <ListItemButton>
              <ListItemText onClick={() => {toggleAvailability(); navigate("/specialevents",{state:activeEvents})}} primary={"Special Events"} />
            </ListItemButton>
          </ListItem>
           )} 
           {(activeApps.find(o => o.appAbbr === 'avl') !== undefined ? activeApps.find(o => o.appAbbr === 'avl').result === "True" : null) && personDetails.empStatus !== "Terminated" && (
          <ListItem key={"availabilityid1"} disablePadding>
            <ListItemButton>
              <ListItemText onClick={() => {toggleAvailability();navigate("/availabilityselections",{state:businessDate})}} primary={"Availability Selections"} />
            </ListItemButton>
          </ListItem>
          )}
          {(personStaticDetails.avail_admin === "A" || personStaticDetails.avail_admin === "D") &&
          <ListItem key={"availabilityid2"} disablePadding>
            <ListItemButton>
              <ListItemText onClick={() => {toggleAvailability();navigate("/controls")}} primary={"Controls"} />
            </ListItemButton>
          </ListItem>
          }
          {(activeApps.length === 0 && !isEventsVisible && personDetails.avail_admin !== "T") && (
          <>
            <ErrorComponent
              message={messages.WFM_NO_ACTIONS}
              variant="danger"
              style={{ marginTop: "38px" }}
            />
          </>
        )
        }
      </List>
    </Box>
  );
  // side drawer ends


  const setImpersonatePersonHandler = (event) => {
    setImpersonatePerson(event.target.value);
  };

  const impersonateBoxOpen = () => {
    setImpersonateBox(true);
    setImpersonatePerson("");
    setIsInvalidEmployee(false);
  };

  const impersonateBoxClose = () => {
    setImpersonateBox(false);
  };

  const impersonatePersonHandler = () => {
    // call api to fetch impersonate persons details
    let adminUser = personDetails.emplID;
    let wfmError = false;

   
    try {
      //store.dispatch(personActions.resetPersonState())
      let url = 
      `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_PERSON}/${impersonatePerson}`;

     // let url =
      //  `${environmentVariables.wfmCommonApiUrl}person/${impersonatePerson}`;  
      const response = axiosInstance
        .get(url,
          {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + token,
              }
          })
        .then((response) => {
          if (response.status == 200) {
            
            let data = response.data;
            store.dispatch(personActions.updatePersonState({ ...data }));
            store.dispatch(
              personActions.updatePersonState({
                impersonate_admin_id: adminUser,
              })
            );
            impersonateBoxClose();
            setIsInvalidEmployee(false);
            
            //Clearing ODS Future Redux on Impersonate change
            store.dispatch(workScheduleActions.resetWorkScheduleState());
            // calling this to fix the work schedule. Whenever impersonate is done need to update work schedule
            axiosInstance.get( `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${impersonatePerson}`, {
              headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
              .then((response) => {
               console.log("response is",response.data)
               if (response.data.length === 0){
                store.dispatch(ODSFutureActions.resetODSFutureState());
                navigate("/");
                navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
                //throw new Error("Empty workSchedule");
                return;
               }
               let data = response.data;
               store.dispatch(workScheduleActions.setWorkScheduleState([...data]));

               //TODO: check this whether we ccan get multiple record or not
               const filterByExpiration = () => data.filter(({ adjstddate }) => new Date(adjstddate) <= new Date());
               let filter = filterByExpiration();
               var max = filter.length > 0 ? filter.reduce(function (a, b) { return a.adjstddate > b.adjstddate ? a : b; }) : null;
               console.log("max",max)
               store.dispatch(ODSFutureActions.setODSFutureState({...max}));

               //TODO: verify this
               navigate("/");
              })
              .catch((error) => {
                
                console.error("This is an issue "+error)
                 if(error.message === 'Network Error') {
                  history("/somethingwentwrong", {state:`Please logout and try again `})
                } else if (error.message === 'Empty workSchedule') {
                  history("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`})
                  let data= {};
                  let wsData =[];
                  store.dispatch(workScheduleActions.resetWorkScheduleState());
                  store.dispatch(ODSFutureActions.resetODSFutureState());

                } else {
                  history("/somethingwentwrong", {state:`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${impersonatePerson}...failed`})
                  } 
                // error
                // Todo: remove once api is up
               // store.dispatch(workScheduleActions.setWorkScheduleState([ ...data ])); 
                
              }) 


            //navigate("/");
          } // if
        }) // then
        .catch((error) => {
          // error logic
          setIsInvalidEmployee(true);
        }); // response catch
    } catch (error) {} // catch
  };

  const stopImpersonatePersonHandler = () => {
    // call api to fetch impersonate persons details
    let adminUser = personDetails.impersonate_admin_id;
    
    try {
      store.dispatch(personActions.resetPersonState())
      let url =
      `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_PERSON}/${adminUser}`;
        //`${urlDetails.uiEnvUrls.REACT_APP_WFM_WFMCOMMON_BASE_URL}person/${adminUser}`;
      //let url =
        //`${environmentVariables.wfmCommonApiUrl}person/${adminUser}`;    
      const response = axiosInstance
        .get(url, {
          headers: {
            'content-type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        })
        .then((response) => {
          if (response.status == 200) {
            /*console.log("success on person!")
          console.log("Person data: ") 
          console.dir((response.data)) */
            let data = response.data;
            store.dispatch(personActions.updatePersonState({ ...data }));
            store.dispatch(
              personActions.updatePersonState({ impersonate_admin_id: null })
            );
            setImpersonatePerson("");

            // reset ODS Future redux on impersonate stop 
            //store.dispatch(workScheduleActions.resetWorkScheduleState());
            // calling this to fix the work schedule. Whenever stop impersonate is done need to update work schedule
            axiosInstance.get(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${adminUser}`, {
              headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })
              .then((response) => {
               console.log("response is",response.data)
               let data = response.data;
               if (response.data.length === 0){
                store.dispatch(ODSFutureActions.resetODSFutureState());
                window.location.reload();
                //navigate("/");
               // navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
                throw new Error("Empty workSchedule");
                //return;
               }
               store.dispatch(workScheduleActions.setWorkScheduleState([...data]));

               //TODO: check this whether we ccan get multiple record or not
               const filterByExpiration = () => data.filter(({ adjstddate }) => new Date(adjstddate) <= new Date());
               let filter = filterByExpiration();
               var max = filter.length > 0 ? filter.reduce(function (a, b) { return a.adjstddate > b.adjstddate ? a : b; }) : null;
               console.log("max",max)
               store.dispatch(ODSFutureActions.setODSFutureState({...max}));

               //TODO: need to verify this
               //navigate("/");
               window.location.reload();
              })
              .catch((error) => {
                if(error.message === 'Network Error') {
                  history("/somethingwentwrong", {state:`Please logout and try again `})
                } else if (error.message === 'Empty workSchedule') {
                  let data= {};
                  store.dispatch(ODSFutureActions.resetODSFutureState());
                  navigate("/somethingwentwrong", {state:`Empty Workschedule, please choose another user.`}) ;
                }
                else {
                  history("/somethingwentwrong", {state:`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAIL_FUTURE_PERSON}/${adminUser}...failedaftr`})
                  }
                // error
                // Todo: remove once api is up
               // store.dispatch(workScheduleActions.setWorkScheduleState([ ...data ])); 
                
              }) 

            navigate("/");
          } // if
        }) // then
        .catch((error) => {
          // error logic
        }); // response catch
    } catch (error) {} // catch

    
  };
  return (
    <>
  
    
      <header>
      
        <div className={"container-fluid" + " " + `${classes.navigation}`}>
          <div className={classes.menulogo}>
            <div className={classes.menu} onClick={impersonateBoxClose}>
              <AiOutlineMenu onClick={toggleDrawer('left', true)} />
            </div>
            <React.Fragment key={'left'}>
        <Drawer
          anchor={'left'}
          open={state['left']}
          onClose={toggleDrawer('left', false)}
          PaperProps={{
            sx: {
              display: 'flex',
              top: '61px',
              height: "300px",
              padding: "0px !important"
            },
          }}
        >
          {list('left')}
        </Drawer>
        <Drawer anchor='left' open={logoutDrawer} onClose={() => { setLogoutDrawer(false); }} 
        PaperProps={{
          sx: {
            display: 'flex',
            top: '61px',
            height: "300px",
            padding: "0px !important"
          },
        }}>
        {listLogout('left')}
        </Drawer>
        <Drawer anchor='left' open={availabilityDrawer} onClose={() => { setAvailabilityDrawer(false); }} 
        PaperProps={{
          sx: {
            display: 'flex',
            top: '61px',
            height: "300px",
            padding: "0px !important"
          },
        }}>
        {listAvailability('left')}
        </Drawer>
      </React.Fragment>
            <div className="logo">
              <img src={logo} />
            </div>
            <div className="verticaldivider"></div>
            <div className={classes.title}><Link onClick={() => navigate("/")} style={{color: "#000", textDecoration: "none", cursor: "pointer"}}>Workforce Management</Link></div>
          </div>
          <div className={classes.details}>
          <label className= {classes.translate}>Select Language</label>
          <div id="google_translate_element" className= {classes.translate}></div>
            {/* <div className="division">
              { (personDetails.msp_AllowImpersonate !== null || personDetails.impersonate_admin_id !== null ) &&
              <>
              <input type="text" value={impersonatePerson} onChange={setImpersonatePersonHandler} /> &nbsp;
              { personDetails.impersonate_admin_id === null ? <button onClick={impersonatePersonHandler}>Impersonate</button>: <button onClick={stopImpersonatePersonHandler}>Stop Impersonating</button> }
              
              </>
              }
              </div>
              { (personDetails.msp_AllowImpersonate !== null || personDetails.impersonate_admin_id !== null) &&  
                <div className="verticaldivider"></div>
              } */}
            <div className={classes.division}>Division: {personDetails.mydiv}</div>
            <div className={classes.verticaldivider}></div>
            <div className={classes.store}>Store: {personDetails.mystore}</div>
            <div className={classes.verticaldivider}></div>
            <div className={classes.emp} translate="no">
              {personDetails.emplID} - {personDetails.fullName}
            </div>
            {(personDetails.msp_AllowImpersonate !== null ||
              personDetails.impersonate_admin_id !== null) && (
              <>
                <div className={classes.verticaldivider}></div>
                <div className={classes.verticaldividertab}></div>
                {personDetails.impersonate_admin_id === null ? (
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={impersonateBoxOpen}
                    className={classes.user}
                  >
                    Act As User
                  </span>
                ) : personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined && (
                  <span
                    style={{ textDecoration: "underline", color: "#949494" }}
                    className={classes.user}
                  >
                    Act As User
                  </span>
                )}
              </>
            )}
            <>
              <div className={classes.verticaldivider}></div>
              <div className={classes.verticaldividertab}></div>
                <span
                  style={{ textDecoration: "underline", cursor: "pointer" }}
                  onClick={logout}
                  class={classes.logout}
              >
                Logout
              </span>
            </>
          </div>
        </div>
      </header>
      <section>
      {(personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined) &&
        <div style={{width: "100%", marginBottom: pathnames.length <=0 ? "0px" : "10px"}}>
      
          <div className={classes.impersonate}>
            <div className={classes.impersonateLeft} >You are currently acting as {personDetails.emplID} - <span translate="no">{personDetails.fullName}</span></div>
            <div className={classes.fillspace}></div>
            <div className={classes.impersonateRight}><Button className={classes.stopImpersonate} style={{background: "#fff", color: "#000"}} onClick={stopImpersonatePersonHandler}>Stop As User</Button></div>
          </div>
          
          </div>
      }
      </section>
      <BreadcrumbView/>
      <main>
        <section>
          <div>
            <div>
              {isImpersonateBoxOpen && (
                <div className={`${classes.impersonateBox}`}>
                  <div className={classes.boxTitle}>Act as user</div>
                  <div className={classes.close} onClick={impersonateBoxClose}>
                    <AiOutlineClose />
                  </div>
                  <div className={classes.employee}>
                    <FormControl sx={{ m: 1, width: "24ch" }}>
                      <TextField
                        error={isInvalidEmployee}
                        helperText={
                          isInvalidEmployee ? "Invalid Colleague ID" : null
                        }
                        id="outlined"
                        label="Enter colleague ID"
                        value={impersonatePerson}
                        onChange={setImpersonatePersonHandler}
                      />
                    </FormControl>
                    {/* <input className={classes.inputText} type="text" value={impersonatePerson} onChange={setImpersonatePersonHandler} /> */}
                    <br />
                  </div>
                  <div className={classes.employee}>
                    <button
                      className={classes.btnPrimary}
                      onClick={impersonatePersonHandler}
                    >
                      <div className={classes.btnLabel}>Login</div>
                    </button>
                  </div>
                  
                </div>
              )}
            </div>
          </div>
        </section>
        <section>
          <Outlet />
        </section>
      </main>
      
    </>
  
  );
};

export default Home;
